export default "__VITE_ASSET__d69aa88f__"